import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-shrink: 0;
`;

export const ButtonWrapper = styled('div')<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ disabled }) => disabled && 'cursor: default;'}
`;
